import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { apiServices } from "../../service/apiServices";

const namespace = "User";

export const getUserList = createAsyncThunk(
    `${namespace}/getUserList`,
    async (body, { rejectWithValue }) => {
      const api = "userlists";
      const opt = {
        body: body,
      };
  
      try {
        const response = await apiServices(api, opt);
        return response.data;
      } catch (err) {
        return rejectWithValue(err);
      }
    }
  );

  const initialState ={

  };

  const userSlice = createSlice({
    name:"user",
    initialState,
    reducers:{},
  });

  export default userSlice.reducer;